import api from '@/api/index.js'

const account_associations = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_ASSOCIATIONS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_ASSOCIATIONS: (state, journeys) => {
      state.data = journeys
      state.loading = false
    },
    SET_ACCOUNT_ASSOCIATIONS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    LoadAccountAssociations({commit}, id) {
      commit('SET_ACCOUNT_ASSOCIATIONS_ERROR', null)
      commit('SET_ACCOUNT_ASSOCIATIONS_LOADING', true);
      return api.get(`accounts/${id}/associations?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_ASSOCIATIONS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ASSOCIATIONS_LOADING', false);
          commit('SET_ACCOUNT_ASSOCIATIONS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
        })
    }
  }
}

export default account_associations
